import React, { useState, useEffect } from 'react';
import { MDBContainer } from 'mdbreact';
import DataTable from '../Components/DataTable';

export default function EventPage() {
  const [eventData, setEventData] = useState(null);
  const [eventDataError, setEventDataError] = useState(false);
  const baseURL = process.env.REACT_APP_API_BASEURL;

  const columns = [
    {
      name: 'Event Name',
      options: {
        filter: false,
      },
    },
    { name: 'Category' },
    {
      name: 'Event Date',
      options: {
        filter: false,
      },
    },
  ];

  useEffect(() => {
    fetch(`${baseURL}/api/activity`)
      .then((res) => res.json())
      .then((res) => {
        // Selecting only a few columns to display
        // Columns excluded: ID, is_updated, comments, min and max suggested hours
        // Changes in these need to be updated in the columns variable above
        // These are not relevant to the user-facing part
        if (res) {
          if (res.activities) {
            const { activities } = res;
            const data = [];
            activities.forEach((activity) => {
              // TODO: Include only activities with is_updated===true
              data.push({
                name: activity.display_name,
                category: activity.category,
                date: activity.event_date,
              });
            });
            setEventData(data);
          }
        }
      })
      .catch((err) => {
        // console.log(err);
        setEventDataError(true);
      });
  }, [baseURL]);

  return (
    <MDBContainer style={{ marginTop: '30px' }} fluid>
      <p className="h2 text-center mb-2">Past NSS Events</p>
      <DataTable
        tableName="Events"
        data={eventData}
        error={eventDataError}
        columns={columns}
        options={{
          rowsPerPage: 15,
          rowsPerPageOptions: [10, 15, 20, 25, 50, 100],
          download: false,
        }}
      />
    </MDBContainer>
  );
}
